import { motion } from "framer-motion";
import { Logo } from "@/components/Logo";

export const inputCls =
  "mt-2 h-12 w-full rounded-2xl border border-ph-line bg-ph-bg px-4 text-ph-ink outline-none transition-[border-color,box-shadow] focus:border-ph-accent/60 focus:shadow-[0_0_0_4px_rgb(var(--ph-accent)/0.12)]";
export const primaryBtnCls =
  "mt-8 flex h-12 w-full items-center justify-center gap-2 rounded-full bg-ph-lime font-semibold text-ph-navy transition-[box-shadow,transform] duration-300 hover:scale-[1.01] hover:shadow-[0_0_30px_rgba(182,255,92,0.45)] disabled:opacity-60";

export function AuthShell({ onSubmit, testId, title, subtitle, children }) {
  return (
    <section className="relative flex min-h-[100svh] items-center justify-center overflow-hidden px-5 py-32">
      <div className="ph2-grid absolute inset-0" />
      <div className="ph2-orb absolute left-1/2 top-1/2 h-96 w-96 -translate-x-1/2 -translate-y-1/2 rounded-full bg-ph-violet/20 blur-[100px]" />
      <motion.form
        onSubmit={onSubmit}
        initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
        className="relative w-full max-w-md rounded-[2rem] border border-ph-line bg-ph-surface/85 p-8 shadow-[0_40px_80px_-40px_rgba(16,22,37,0.6)] backdrop-blur-xl sm:p-10"
        data-testid={testId}
      >
        <Logo />
        <h1 className="mt-10 font-display text-4xl font-extrabold tracking-tight text-ph-ink">{title}</h1>
        <p className="mt-2 text-sm text-ph-muted">{subtitle}</p>
        {children}
      </motion.form>
    </section>
  );
}
